module.exports = __webpack_public_path__ + "img/img-5.dc469527.png";